import { Box } from "@mui/material";

export const LabelWithIcon = ({ icon: Icon, label, img }) => {
  return (
    <Box display={"flex"} alignItems={"center"} gap={"6px"}>
      {Icon ? <Icon size={"16"} /> : <></>}
      {img ? (
        <img src={img} alt={label} width={"16px"} height={"16px"} />
      ) : (
        <></>
      )}
      {label}
    </Box>
  );
};
